import { routes } from "src/lib/routes";
import { create } from "zustand";
import { LoadingStates } from "./projectStore";

const initialState = {
  page: 0,
  size: 10,
  userList: [],
};

interface UserStore {
  page: number;
  size: number;
  userList: Array<any> | LoadingStates;
  updatePage: (p: number) => void;
  getAllUsers: (data: any) => Promise<void>;
}

export const userStore = create<UserStore>((set, get) => ({
  ...initialState,

  updatePage(page: number) {
    set({ page: page });
  },

  async getAllUsers({ emailId }) {
    set({ userList: LoadingStates.LOADING })
    
    if (emailId) {
      set({ page: 0 });
    }
    const res = await routes.APIS.USER.GET_ALL_USER({
      page: get().page,
      size: get().size,
      emailId,
    });
    set({ userList: res });
  },
}));
